/* eslint-disable no-underscore-dangle */ import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { useKeyNavigation } from "@silvertours/front-entities";
import { Theme } from "@silvertours/front-shared";
import { StyledList, StyledButton, ErrorMessage, ListItem } from "./LocationSuggest.styles";
import { SearchResultItem } from "./SearchResultItem";
import { useSearchContext } from "../context";
import { useStageContext } from "../../StageLegacy";
var LocationSuggest = function(param) {
    var connectedInputContainer = param.connectedInputContainer, onLastElementBlur = param.onLastElementBlur, loading = param.loading, onItemClick = param.onItemClick, results = param.results;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    var state = useSearchContext().state;
    var setStageImage = useStageContext().setStageImage;
    var listRef = useRef(null);
    var isMobileTouchDevice = Theme.useIsMobileTouchDevice();
    var handleEnter = function(item) {
        onItemClick(item);
    };
    var ref = useKeyNavigation(results || [], listRef, handleEnter), focusedItem = ref.focusedItem, onMouseEnter = ref.onMouseEnter, onMouseLeave = ref.onMouseLeave;
    useEffect(function() {
        if (isMobileTouchDevice && (connectedInputContainer === null || connectedInputContainer === void 0 ? void 0 : connectedInputContainer.current)) {
            connectedInputContainer.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isMobileTouchDevice,
        connectedInputContainer
    ]);
    var handleClick = function(suggestion) {
        onItemClick(suggestion);
        setStageImage(suggestion.image_path);
    };
    if (!loading && !(results === null || results === void 0 ? void 0 : results.length) && !(state === null || state === void 0 ? void 0 : state.depLocation)) {
        return /*#__PURE__*/ _jsx(ErrorMessage, {
            children: t("errorTexts.dep")
        });
    }
    return results && /*#__PURE__*/ _jsx(StyledList, {
        ref: listRef,
        id: "locationSuggest",
        children: results.map(function(suggestion, index) {
            return /*#__PURE__*/ _jsx(ListItem, {
                children: /*#__PURE__*/ _jsx(StyledButton, {
                    type: "button",
                    tabIndex: 0,
                    onBlur: onLastElementBlur,
                    onMouseDown: function() {
                        return handleClick(suggestion);
                    },
                    onMouseEnter: function() {
                        return onMouseEnter(index);
                    },
                    onMouseLeave: onMouseLeave,
                    id: "locationSuggestItem-".concat(index + 1),
                    "aria-selected": index === focusedItem,
                    children: /*#__PURE__*/ _jsx(SearchResultItem, {
                        suggestion: suggestion
                    })
                })
            }, suggestion.objectID);
        })
    });
};
export { LocationSuggest };
